import { Fragment, useState, useEffect } from 'react'
import { formatMoney, stringToFloat } from '../helpers/Common'
import { SimuladorBeneficiosFAQ } from '../data/simulador-beneficios-faq'
import Tooltip from '../blocks/Tooltip'
import PerguntasFrequentes from '../blocks/PerguntasFrequentes'

const SimuladorBeneficios = (props) => {

    const foto = require('../../assets/images/foto-01.png')

    const RENDA_MINIMA = 50000

    const [values, setValues] = useState({
        renda: 0,
        saldo: 0,
        provisao: 0
    })
    const [total, setTotal] = useState(false)
    const [showValues, setShowValues] = useState({
        renda: '',
        saldo: '',
        provisao: ''
    })
    const [errors, setErrors] = useState({
        renda: false,
        saldo: false,
        provisao: false
    })

    const getShowValue = (field) => {
        return showValues[field]
    }

    const setValue = (event) => {

        const formated = formatMoney(event.target.value);
        const realval = stringToFloat(formated);
        setValues(values => ({
            ...values,
            [event.target.name]: realval
        }))
        setShowValues(showValues => ({
            ...showValues,
            [event.target.name]: formated
        }))

    }

    const validate = (event, value) => {

        if (!event?.target) return;

        const realval = (value ? value : stringToFloat(event.target.value))

        if (event.target.name === 'renda') {

            if (value !== undefined) {

                const success = (!realval || realval === '' || parseFloat(value) >= RENDA_MINIMA)
                if (success) {
                    setErrors(errors => ({
                        ...errors,
                        renda: false
                    }))
                }

            }
            else {

                const error = ((realval && realval !== '' && parseFloat(realval) < RENDA_MINIMA) ? 'O simulador está disponível apenas para rendas anuais a partir de R$ 50.000,00.' : false)

                setErrors(errors => ({
                    ...errors,
                    renda: error
                }))

            }

        }

    }

    useEffect(() => {

        const
            renda = parseFloat(values.renda),
            saldo = parseFloat(values.saldo),
            provisao = parseFloat(values.provisao)
        ;

        if( saldo === 0 && provisao === 0 ){
            setTotal( false )
        }
        else {
            
            let total = 0;
            if (renda >= RENDA_MINIMA && (saldo > 0 || provisao > 0 ) ){
                total = ((renda * 0.12) - ( saldo + provisao ))
            }

            setTotal( total )

        }

    }, [values])

    return (

        <Fragment>

            <section id="conquiste">
                <div className="center">
                    <div className="left">
                        <h1>Conquiste segurança para o futuro e pague menos imposto agora</h1>
                        <p>Descubra quanto investir na sua previdência com a BB Previdência para aproveitar ao máximo a economia
                            no Imposto de Renda e garantir mais tranquilidade lá na frente.</p>
                        <a href="#simule" className="button">Simular agora</a>
                    </div>
                    <div className="right">
                        <picture>
                            <img src={foto.default} alt="Mulher dando risada" />
                        </picture>
                    </div>
                </div>
            </section>

            <section id="descubra">
                <div id="simule" className="center">
                    <div className="top">
                        <ol className="passos" start="1">
                            <li>
                                <em>Informe sua renda</em>
                                <p>Informe sua renda bruta anual (sem incluir o 13º salário)</p>
                            </li>
                            <li>
                                <em>Quanto já contribuiu?</em>
                                <p>Preencha quanto você já contribuiu neste ano (considere apenas as contribuições feitas por você)</p>
                            </li>
                            <li>
                                <em>Descubra quanto investir</em>
                                <p>Veja quanto ainda pode investir para atingir o limite de dedução no Imposto de Renda.</p>
                            </li>
                        </ol>
                    </div>
                    <form className="bottom">
                        <div>
                            <div className="header">
                                <h3>Renda Bruta Anual (sem 13º)</h3>
                                <Tooltip content="Informe o valor da sua renda anual neste ano. Não inclua o 13° salário, pois ele não entra no cálculo da dedução." />
                            </div>
                            <input type="text" name="renda" value={getShowValue('renda')} className={errors?.renda ? 'error' : null} onChange={setValue} onBlur={validate} maxLength="17" placeholder="R$ 100.000,00" />
                            {errors?.renda && <div className="report">{errors.renda}</div>}
                        </div>
                        <div>
                            <div className="header">
                                <h3>Quanto você já contribuiu este ano (apenas as contribuições feitas por você)</h3>
                                <Tooltip content="Digite o valor total que você já investiu no seu plano de previdência até agora." />
                            </div>
                            <input type="text" name="saldo" value={getShowValue('saldo')} className={errors?.saldo ? 'error' : null} onChange={setValue} maxLength="17" placeholder="R$ 5.000,00" />
                        </div>
                        <div>
                            <div className="header">
                                <h3>Quanto você ainda pretende contribuir até dezembro</h3>
                                <Tooltip content="Considere o valor das suas contribuições mensais até dezembro e informe aqui o total previsto." />
                            </div>
                            <input type="text" name="provisao" value={getShowValue('provisao')} className={errors?.provisao ? 'error' : null} onChange={setValue} maxLength="17" placeholder="R$ 5.000,00" />
                        </div>
                    </form>
                    {total < 0 && 
                        <em class="limit-message">Você já atingiu o limite de dedução no Imposto de Renda, mas pode continuar investindo para fortalecer ainda mais sua aposentadoria.</em>}
                </div>
            </section>

            <section id="pode-investir">
                <div className="center">
                    {( total === false || total > 0 ) &&
                    <div className="top">
                        <h2>Este é o valor que você ainda pode investir este ano para aproveitar ao máximo a dedução no seu
                            Imposto de Renda</h2>
                        <div className="valor-necessario">
                            <div>
                                <div className='header'>
                                    <em>Valor necessário de aporte</em>
                                    <Tooltip content="Este é o valor que você ainda pode investir para aproveitar o limite de dedução de 12% da renda anual no Imposto de Renda." />
                                </div>
                                {/* <strong className={(total > 0 ? 'fill' : 'empty')}> {total > 0 ? formatMoney(total) : 'R$'}</strong> */}
                                <strong className={total > 0 ? 'fill' : 'empty'}>
                                    {total > 0 && formatMoney(total) }
                                    {total === false && 'R$'}
                                </strong>
                            </div>
                        </div>
                    </div>}

                    <div className="bottom">
                        {( total && total > 0 ) &&
                            <h3>Você pode economizar imposto se investir mais R$ {formatMoney(total)} na sua previdência com a BB Previdência.
                                <br /> Não perca essa oportunidade!
                            </h3>}
                        <a href="/passo-a-asso-aporte-adicional.pdf" className="button" target="_blank">Como fazer aporte adicional no meu plano</a>
                        <em><strong>Importante:</strong> Este simulador tem caráter apenas informativo e não gera qualquer
                            obrigação para a BB Previdência. O cálculo considera apenas o limite de 12% da renda bruta anual
                            tributável, definido pela Receita Federal. Outros fatores, como dependentes, despesas médicas,
                            educação e demais deduções legais, também influenciam no valor final do seu Imposto de Renda.</em>
                    </div>
                </div>
            </section>

            <section id="faq">
                <div className="center">
                    <div className='header'>
                        <h2>Dúvidas?</h2>
                        <em>Conheça as principais dúvidas sobre a BB Previdência</em>
                    </div>
                    <PerguntasFrequentes data={SimuladorBeneficiosFAQ} />
                </div>
            </section>

        </Fragment>)

}
export default SimuladorBeneficios